import { callable } from '@tencent/tiny-ioc';
import { OfflineEditServices } from '../core/offline-edit-service.core';
import { OfflineEditContext } from '../services/offline-edit-context';
import { OfflineDBService } from '../services/offline-db-service';
import { OfflineCacheService } from '../services/offline-cache-service';
import { OfflineEditService } from '../services/offline-edit-service';

export function registerOfflineSlideDataServices() {
    // 创建并注册离线编辑上下文
    OfflineEditServices.OfflineEditContext.register(callable(OfflineEditContext));
    // 离线编辑数据库相关服务
    OfflineEditServices.OfflineDBService.register(callable(OfflineDBService));
    // 获取缓存状态 & 设置缓存
    OfflineEditServices.OfflineCacheService.register(callable(OfflineCacheService));
    // 在线文档支持离线编辑
    OfflineEditServices.OfflineEditService.register(callable(OfflineEditService));
}
